export const MINICART_CROSS_SELL_EVENT_SOURCE = 'mini cart vitrine cross sell'

export const MINICART_CROSS_SELL_PRODUCT_LIST_NAME =
  'Vitrine compre junto mini cart'
